import React, { MouseEvent } from 'react';
import { capitalize } from 'annotator/annotator-helpers';

interface QABooleanButtonsProps {
  result: Record<string, unknown>;
  buttonKey: string;
  buttonText: string;
  onUpdate: (result: Record<string, unknown>) => void;
  selected?: boolean;
  readOnly: boolean;
}

const QABooleanButtons: React.FC<QABooleanButtonsProps> = ({
  result, buttonKey, buttonText, onUpdate, selected, readOnly
}) => {
  const buttons = buttonText.split('/');

  return (
    <div className="qa-boolean-buttons">
      {
        buttons.map((button, index) => {
          let buttonSelected = null;
          if (selected !== null && selected !== undefined) {
            buttonSelected = index === 0 ? selected : !selected;
          }

          return (
            <button
              key={button}
              type="button"
              value={index === 0 ? 'true' : 'false'}
              onClick={(event: MouseEvent<HTMLButtonElement>) => {
                const value = event.currentTarget.value === 'true';
                const updatedResult = { ...result, [buttonKey]: value };
                onUpdate(updatedResult);
              }}
              className={`btn btn-primary${buttonSelected ? '' : '-outline'} ${index === 0 ? 'me-1' : ''}`}
              disabled={readOnly}
            >
              <span>{capitalize(button)}</span>
            </button>
          );
        })
      }
    </div>
  );
};

export default QABooleanButtons;
